import SETUP_WIZARDS_STEPS, { SETUP_WIZARDS } from '@/constants/setup-wizards'
// import USER_TYPES from '@/constants/authorization/user-types'
import store from '@/store'
import { BUSINESS_FEATURES } from '@/constants/business-types'
// import { PACKAGE_PERMISSIONS } from '@/constants/features'
import SUBUSER_PERMISSION_SLUGS from '@/constants/authorization/subuser-permission-slugs'

export default [
  // {
  //   header: 'navigation.setup-account',
  // },
  // {
  //   title: 'navigation.ordering',
  //   icon: 'ShoppingBagIcon',
  //   tagVariant: 'light-warning',
  //   userTypes: [USER_TYPES.KITCHEN_SUPERVISOR, USER_TYPES.BRANCH_ADMIN],
  //   children: [
  //     {
  //       title: 'ordering.services',
  //       wizard: SETUP_WIZARDS.SERVICES,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.SERVICES]?.stepsNames ?? [],
  //       userTypes: [USER_TYPES.KITCHEN_SUPERVISOR, USER_TYPES.BRANCH_ADMIN],
  //       route: 'admin:services-wizard',
  //     },
  //     {
  //       title: 'payment-methods.payment-methods',
  //       wizard: SETUP_WIZARDS.PAYMENT_METHODS,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.PAYMENT_METHODS]?.stepsNames ?? [],
  //       userTypes: [USER_TYPES.BRANCH_ADMIN],
  //       route: 'admin:payment-methods-wizard',
  //     },
  //   ],
  // },
  {
    title: 'navigation.menu-setup',
    svgIcon: 'icon-menu-setup',
    permission: [
      SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
      SUBUSER_PERMISSION_SLUGS.MENU_MANAGE,
      SUBUSER_PERMISSION_SLUGS.MENU_BULK_VIEW,
      SUBUSER_PERMISSION_SLUGS.MENU_BULK_MANAGE,
      SUBUSER_PERMISSION_SLUGS.MENU_SYNC,
      SUBUSER_PERMISSION_SLUGS.BRANCHES_SETTINGS_VIEW,
    ],
    children: [
      {
        title: 'my-menu.my-menu',
        wizard: SETUP_WIZARDS.MENU,
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.MENU]?.stepsNames ?? [],
        route: 'admin:my-menu',
        svgIcon: 'icon-my-menu',
        permission: SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
      },
      {
        title: 'bulk-menu.title',
        route: 'admin:bulk-menu',
        svgIcon: 'icon-bulk-menu',
        permission: [
          SUBUSER_PERMISSION_SLUGS.MENU_BULK_VIEW,
          SUBUSER_PERMISSION_SLUGS.MENU_BULK_MANAGE,
        ],
      },
      {
        title: 'my-menu.pos-menu.title',
        icon: 'MonitorIcon',
        route: 'admin:pos-menu',
        permission: SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
        hide: () => !store.getters['integrations/enabledPOSIntegration'] || store.getters['integrations/enabledPOSIntegration']?.integration?.slug,
      },
      {
        title: () => `my-menu.pos-menu.${store.getters['integrations/enabledPOSIntegration']?.integration.slug}`,
        wizard: SETUP_WIZARDS.POS,
        svgIcon: 'icon-pos-menu',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.POS]?.stepsNames ?? [],
        route: 'admin:pos-menu',
        permission: SUBUSER_PERMISSION_SLUGS.MENU_VIEW,
        hide: () => !store.getters['integrations/enabledPOSIntegration'] && !store.getters['integrations/enabledPOSIntegration']?.integration.slug,
      },
      {
        title: 'modifiers.modifiers',
        wizard: SETUP_WIZARDS.MODIFIERS,
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.MODIFIERS]?.stepsNames ?? [],
        route: 'admin:modifiers',
        svgIcon: 'icon-modifiers',
        permission: SUBUSER_PERMISSION_SLUGS.MODIFIERS_VIEW,
        hide: () => !store.getters['businessTypes/isEnabled'](BUSINESS_FEATURES.MODIFIERS),
      },
      {
        title: 'custom-inputs.custom-inputs',
        route: 'admin:custom-inputs',
        svgIcon: 'icon-custom-input',
        tag: 'upgrade',
        tagPackagePermission: SUBUSER_PERMISSION_SLUGS.CUSTOM_INPUTS_VIEW,
        tagAddonSlug: 'custom-inputs',
        hide: () => !store.getters['subscription/isCustomInputsPurchased'] || !store.getters['auth/user'].enable_custom_inputs,
      },
      {
        title: 'cloud.okmenu-cloud',
        wizard: SETUP_WIZARDS.CLOUD,
        route: 'admin:cloud',
        svgIcon: 'icon-okmenu-cloud',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.CLOUD]?.stepsNames ?? [],
        permission: SUBUSER_PERMISSION_SLUGS.MEDIA_VIEW,
      },
      {
        title: 'taxes.okmenu-taxes',
        wizard: SETUP_WIZARDS.TAXES,
        route: 'admin:taxes',
        svgIcon: 'icon-extra-taxes',
        stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.TAXES]?.stepsNames ?? [],
        permission: [
          SUBUSER_PERMISSION_SLUGS.TAXES_VIEW,
          SUBUSER_PERMISSION_SLUGS.TAX_GROUPS_VIEW,
        ],
      },
    ],
  },
  // {
  //   title: 'navigation.publishing',
  //   icon: 'UploadCloudIcon',
  //   children: [
  //     {
  //       title: 'navigation.qr',
  //       wizard: SETUP_WIZARDS.QR_CODE,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.QR_CODE]?.stepsNames ?? [],
  //       route: 'admin:qr',
  //       hide: () => !store.getters['permissions/isPrimaryAccount'],
  //     },
  //     {
  //       title: 'navigation.devices',
  //       wizard: SETUP_WIZARDS.DEVICES,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.DEVICES]?.stepsNames ?? [],
  //       tag: 'upgrade',
  //       tagPackagePermission: PACKAGE_PERMISSIONS.IPAD,
  //       route: 'admin:devices',
  //       hide: () => store.getters['subscription/isQr'] || !store.getters['permissions/isPrimaryAccount'],
  //     },
  //     {
  //       title: 'navigation.widget',
  //       wizard: SETUP_WIZARDS.WIDGET,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.WIDGET]?.stepsNames ?? [],
  //       route: 'admin:widget',
  //     },
  //     {
  //       title: 'navigation.domains',
  //       wizard: SETUP_WIZARDS.DOMAIN,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.DOMAIN]?.stepsNames ?? [],
  //       route: 'admin:domain',
  //     },
  //     {
  //       title: 'navigation.google-menu',
  //       wizard: SETUP_WIZARDS.GOOGLE_MENU,
  //       stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.GOOGLE_MENU]?.stepsNames ?? [],
  //       hide: () => !store.getters['viral/canEnableViral'],
  //       route: 'admin:google-menu',
  //     },
  //   ],
  // },
  // {
  //   title: 'navigation.users-notifications',
  //   icon: 'ShoppingBagIcon',
  //   wizard: SETUP_WIZARDS.USERS_WIZARD,
  //   route: 'admin:users-wizard',
  //   stepsNames: SETUP_WIZARDS_STEPS[SETUP_WIZARDS.USERS_WIZARD]?.stepsNames ?? [],
  //   hide: () => !store.getters['permissions/isPrimaryAccount'],
  // },
]
